import AuthService from "./authService";
import CropwiseAuthService from "./cropwiseAuthService";

export var authService;

// export default authService;

export default function initAuthService(authMode){
    let cropWiseModeEnabled = JSON.parse(process.env.VUE_APP_CROPWISE_ENABLED);
    if(authMode == 'cw' & cropWiseModeEnabled){
        authService = new CropwiseAuthService();
    }
    else{
        authService = new AuthService();
    }
    
    return authService;
    
}
